(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.__sibrilleClarityLoaded) return;

  var clarityProjectId = window.__sibrilleClarityProjectId;
  if (!clarityProjectId) return;

  var existingScript = document.querySelector('script[src*="clarity.ms/tag/"]');
  if (existingScript) {
    window.__sibrilleClarityLoaded = true;
    return;
  }

  window.__sibrilleClarityLoaded = true;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', clarityProjectId);
})();
